import React from 'react';
import {connect} from "react-redux";
import {setSelectedFeature, setSelectedPartIds} from "../../../../../../actions/sqftResourceFunctions";
import {FormattedMessage, injectIntl} from "react-intl";
import FeatureThumbnail from "../../../../../visComponents/featureThumbnail";
import {getFeatureGroupName} from "../../../../../../misc/helpers";
import {getCurrentLayout} from "../../../../../appLayout";
import {CABINET_HANDLE_ALLOWED} from "../../../../constants";

const SqftOptionsHandlesContent = (props) => {
  const {selectedPartIds, setSelectedPartIds, selectedFeature, intl, fabricatorData} = props;

  const toggleCabinetsApplyTo = (togglePartId) => {
    let newList = [...selectedPartIds];
    newList.includes(togglePartId)
      ? newList = newList.filter(partId => partId !== togglePartId)
      : newList.push(togglePartId);
    setSelectedPartIds(newList);
  };

  const getButtonName = (partId, layout) => {
    //if (intl.locale !== "en-EN") {
      const featureGroup = layout.getFeatureGroupByPartId(partId);
      if (featureGroup) {
        return getFeatureGroupName(featureGroup, intl, fabricatorData).replace(' Color', '')
      }
    //}
    switch (partId) {
      case "top_cabinet":
        return "Upper cabinet";
      case "bottom_cabinet":
        return "Lower cabinet";
      case "center_island_cabinet":
        return "Center island";
      case "vanity_cabinet":
        return "Cabinet";
      case "vanity_mirror":
        return "Mirror";
      default:
        return ""
    }
  };
  const layout = getCurrentLayout();

  return (
    <div className={"bootstrap-wrapper"}>
      <div className={"container-fluid"}>
        <div className={"row"}>
          <div className={"col-6 message-window-container_fluid"}>
            <FeatureThumbnail feature={selectedFeature.part}/>
            <div>
              <FormattedMessage id="sqft.popup.title.selectedHandle"/> {selectedFeature.part.getFeatureName()}
            </div>
          </div>
          <div className={"col-6 message-window-container_fluid"}>
            {Object.keys(CABINET_HANDLE_ALLOWED).map(partId => {
              const disabledButton = false;
              const checked = selectedPartIds.includes(partId);
              return (
                <div key={"dropdownRelated"+partId}
                     className={"ui-select__dropdown-list-item"}>
                  <span className={"ui-checkbox ui-checkbox--small"
                  + (!disabledButton && checked? " ui-checkbox--checked" : "")
                  + (disabledButton ? " ui-checkbox--disabled" : "")}
                        onClick={() => disabledButton ? false : toggleCabinetsApplyTo(partId)}/>
                  <span className={"ui-checkbox__label" + (disabledButton ? " ui-checkbox__label--disabled" : "")}
                        onClick={() => disabledButton ? false : toggleCabinetsApplyTo(partId)}>
                    {getButtonName(partId, layout)}
                  </span>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {selectedFeature, selectedPartIds} = store.sqftResourceState;
  return {
    menuOpened,
    selectedFeature,
    selectedPartIds,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  setSelectedFeature,
  setSelectedPartIds
};

SqftOptionsHandlesContent.propTypes = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftOptionsHandlesContent)
);
